<template>

    <li @click="addToBasket($event)" :id="'product_' + product.id">
        <a :class="{ 'tl_add': selected }">
            <div class="tl_head">
                <div class="tl_name">
                    {{product.name}}
                </div>
                <div class="tl_head_price" :class="{ 'ios-font': $store.getters.checkIos }">
                    <span v-if="$store.getters.outletSettings.delivery_type !== 4">{{selectedQty}}</span>{{price}}
                </div>
            </div>
            <template v-if="showDescription">
                <div class="tl_info pl_info" v-html="renderDescription(product.description)"></div>
                <div class="fade" v-if="isLong(product.description)"></div>
            </template>
        </a>
    </li>
</template>

<script>
  const marked = require('marked')
  import { mapGetters } from 'vuex'
  import { DISABLE_OVERLAY } from '@/store/actions.type'
  import { SET_CURRENT_PRODUCT, SET_MODAL, SET_SELECTED_PRODUCTS } from '@/store/mutations.type'

  const renderer = {
    code(code, infostring, escaped) {
      return '<p>' + code + '</p>'
    }
  }

  marked.use({ renderer })

  export default {
    name: 'ResourceItem',
    props: {
      product: Object,
    },
    data() {
      return {
        selected: false,
        selectedQty: 0,
      }
    },
    computed: {
      price() {
        if (this.product.prices.min === this.product.prices.max) {
          return this.$options.filters.toCurrency(this.product.prices.min)
        }
        return this.$options.filters.toCurrency(this.product.prices.min) + ' – ' + this.$options.filters.toCurrency(this.product.prices.max)
      },
      ...mapGetters(
        ['priceOnPhoto', 'showDescription', 'imagesStyle', 'IMAGES_SQUARE_MINIATURE', 'IMAGES_SQUARE_LEFT', 'IMAGES_SQUARE_RIGHT', 'IMAGES_WIDE']),
    },
    mounted() {
      this.ifSelected()

      this.$store.subscribe((mutation) => {
        if (mutation.type === SET_SELECTED_PRODUCTS) {
          this.ifSelected()
        }
      })
      if (this.$store.getters.overlay === true) {
        this.$store.dispatch(DISABLE_OVERLAY)
      }
    },
    methods: {
      isLong(description) {
        return description.length >= 110
      },
      renderDescription(description) {
        return marked(this.$options.filters.nl2br(description))
      },

      ifSelected() {
        this.selected = false
        this.selectedQty = 0
        this.$store.getters.selectedProducts.forEach(element => {
          if (element.id === this.product.id) {
            this.selected = true
            this.selectedQty++
          }
        })
      },
      addToBasket(event) {
        this.$store.commit(SET_CURRENT_PRODUCT, this.product)
        this.$store.commit(SET_MODAL, { modal: 'resource', status: true })
      },
    },
  }
</script>

<style scoped>

    div.placeholder {
        width: 100%;
        height: 0;
        background: #f7f7f7;
        position: relative;
    }

    img.placeholded-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
    }
</style>
